import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Atlas } from '../../../../../common-ui/src/routing/atlas/atlas';
import { SUPPORT_EMAIL, SUPPORT_PHONE } from '../../../constants/authentication.constants';
import { ATLAS } from '../../../constants/injector.constants';
import { getRouterLinkUrlById } from '../../../routing/atlas/atlas.helpers';
import { ModalService } from '../../../services/modal/modal.service';

@Component({
    selector: 'lsq-help-modal',
    template: `
        <div class="modal-content">
            <div class="modal-header">
                <h2 i18n>Having trouble logging in?</h2>
            </div>
            <div class="modal-body">
                <p>
                    <ng-container i18n>
                        If you no longer have access to the mobile phone number we have on file,
                        please contact
                    </ng-container>
                    <a href="mailto:{{ supportEmail }}" class="font-weight-bold" i18n>
                        Customer Support
                    </a>
                    <ng-container i18n>for assistance</ng-container>
                </p>
                <br />
                <div>
                    <span class="font-weight-bold">Email: </span>
                    <a href="mailto:{{ supportEmail }}">{{ supportEmail }}</a>
                </div>
                <div><span class="font-weight-bold">Phone: </span> {{ supportPhone }}</div>
            </div>
            <div class="modal-footer">
                <div class="modal-footer-left">
                    <lsq-button
                        size="sm"
                        type="button"
                        appearance="secondary"
                        i18n="Cancel button"
                        (buttonClick)="modalService.closeModal()"
                    >
                        Cancel
                    </lsq-button>
                </div>
                <div class="modal-footer-right">
                    <lsq-button
                        size="sm"
                        type="button"
                        i18n="Back to Login button"
                        (buttonClick)="navigateToLogout()"
                    >
                        Back to Login
                    </lsq-button>
                </div>
            </div>
        </div>
    `
})
export class LsqHelpModalComponent {
    public supportEmail: string;
    public supportPhone: string;

    constructor(
        public modalService: ModalService,
        public router: Router,
        @Inject(ATLAS) public atlas: Atlas
    ) {
        this.supportEmail = SUPPORT_EMAIL;
        this.supportPhone = SUPPORT_PHONE;
    }

    public navigateToLogout(): void {
        this.router.navigateByUrl(getRouterLinkUrlById(this.atlas, 'LOGOUT'));
    }
}
